import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Indexpage from '@/views/Indexpage.vue';
import OverviewSample from '@/views/OverviewSample.vue';
import Loggedin from '@/views/Loggedin.vue';
import store from '@/store/index';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Index',
    component: Indexpage
  },
  {
    path: '/overview-sample',
    name: 'OverviewSample',
    meta: {
      pageTitle: 'Overview Sample',
      requiresAuth: true
    },
    component: OverviewSample
  },
  {
    path: '/logged-in',
    name: 'LoggedIn',
    component: Loggedin
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach( (to, from, next) => {
  if (to.meta.requiresAuth) {
    // このルートはログインされているかどうか認証が必要です。
    // もしされていないならば、ログインページにリダイレクトします。
    if (!store.getters.logged_in) {
      // ここでログインチェックをする
      console.log('=========> ' + to.name);
      store.dispatch('login')
        .then((result) => {
          next();
        })
        .catch((err) => {
          console.log(err);
          // ログイン画面へ
          next('/');
        });
    }
    else {
      next();
    }
  }
  else {
    next();
  }
});

export default router;
